import { useState, useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { addNote } from '../../../../../../services/CaseManagementService';
import { useGetMyProfileQuery } from '../../../../../../services/ProfileService';

interface UseNoteFormReturn {
  noteText: string;
  setNoteText: (text: string) => void;
  isValid: boolean;
  handleSave: () => void;
  handleReset: () => void;
}

export const useNoteForm = (onSuccess?: () => void): UseNoteFormReturn => {
  const [noteText, setNoteText] = useState('');
  const dispatch = useAppDispatch();
  const { data: userProfile } = useGetMyProfileQuery();

  const isValid = noteText.trim().length > 0;

  const handleSave = useCallback(() => {
    if (!isValid) return;

    const newNote = {
      text: noteText.trim(),
      addDate: new Date().toISOString(),
      addedBy: userProfile?.identity || userProfile?.name || 'Unknown User'
    };

    dispatch(addNote(newNote));
    setNoteText('');
    onSuccess?.();
  }, [noteText, isValid, userProfile, dispatch, onSuccess]);

  const handleReset = useCallback(() => {
    setNoteText('');
  }, []);

  return {
    noteText,
    setNoteText,
    isValid,
    handleSave,
    handleReset
  };
};
